<div class="w-full h-full p-5 relative text-gray-1100">
  <div style="height: calc(100% - 100px)" class="overflow-auto">
    <div class="text-center mb-3">
      <h3 class="font-medium text-heading">{{ data.header_text }}</h3>
    </div>
    <div class="text-center">
      <div class="text-paragraph font-normal" [innerHTML]="data.text"></div>
    </div>
  </div>
  <div mat-dialog-actions class="flex mt-4 w-full">
    <div class="pr-1 grow">
      <button
        mat-raised-button
        class="cancel-button bg-gray-100 mat-elevation-z0 text-gray-800 hover:bg-gray-100 focus:bg-gray-100"
        (click)="onClick(false)"
      >
        Cancel
      </button>
    </div>
    <div class="pl-1 grow">
      <button
        (click)="onClick(true)"
        mat-raised-button
        class="confirm-button"
        color="primary"
        data-test="confirm-dialog-button"
      >
        {{ data.confirmation_text }}
      </button>
    </div>
  </div>
</div>
